import { ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

import { useEffect } from 'react';
import { useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

function FormEditor({ disabled, defaultValue, readOnly, onChange }) {
  const generateEditorState = () => {
    try {
      let content;
      if (typeof defaultValue === 'string') {
        content = JSON.parse(defaultValue);
      } else {
        content = defaultValue;
      }
      return content;
    } catch (err) {
      return convertToRaw(ContentState.createFromText(defaultValue));
    }
  };
  const [editorState, setEditorState] = useState(generateEditorState());

  useEffect(() => {
    let content = generateEditorState();
    setEditorState(content);
  }, [defaultValue]);

  if (disabled) {
    let bodyValue;
    let isHtml = false;

    try {
      bodyValue = JSON.parse(defaultValue);
      bodyValue = draftToHtml(bodyValue);
      isHtml = true;
    } catch (err) {
      bodyValue = defaultValue;
      isHtml = false;
    }
    return (
      <div className="border rounded p-3">
        {isHtml ? <div dangerouslySetInnerHTML={{ __html: bodyValue }} /> : <div>{bodyValue}</div>}
      </div>
    );
  }

  return (
    <div>
      <Editor
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor border rounded px-3"
        defaultContentState={editorState}
        onContentStateChange={(e) => onChange(e)}
        readOnly={readOnly}
      />
    </div>
  );
}

export default FormEditor;
